module.exports = __webpack_public_path__ + "static/agency-banner-f499af96d7698e43cf8524afe3a578ac.png";